// Which walk hair sheets nobody draws any more (character look plan 3, Task 10). Every style is two sheets of its own
// (and the default its neck), ~2 MP each pair, and a long session on the street meets many: a phone frees the ones no
// sprite draws when it frees the big backgrounds (PreloadScene _freeUnneeded), and a sprite that wants one again loads
// it again. NatalkaSprite says what it draws (`use`) and when it goes (`release`); the textures themselves are
// Phaser's, so this module only keeps the books.

/** A sheet let go of is kept this long: the free runs 400 ms after a scene starts, before the new scene's sprites
 *  have drawn the hair the old scene's just let go of. */
export const IDLE_MS = 30_000;

const HAIR = /^(natalka|ken)_walk_(hair_.+|hairback_.+|ears_.+|neck)$/;

/** A walk hair sheet: `<c>_walk_hair_<style>`, `<c>_walk_hairback_<style>`, a style's `<c>_walk_ears_<style>` or
 *  `<c>_walk_neck` (not its mask). */
export const isHairSheet = (key) => HAIR.test(key) && !key.endsWith('_mask');

const sheetOf = (key) => (key.endsWith('_mask') ? key.slice(0, -'_mask'.length) : key);

export function createSheetLedger({ now = () => Date.now() } = {}) {
  const held = new Map();                 // owner -> the keys it draws
  const letGo = new Map();                // key -> when its last owner let go of it (or a free first saw it undrawn)
  const holders = (key) => [...held.values()].some((keys) => keys.has(key));
  const drop = (owner, keep = new Set()) => {
    for (const k of held.get(owner) ?? []) if (!keep.has(k)) letGo.set(k, now());
  };
  return {
    /** `owner` draws `keys` now (and nothing else it drew before). */
    use(owner, keys) {
      const next = new Set(keys);
      drop(owner, next);
      held.set(owner, next);
      for (const k of next) letGo.delete(k);
    },
    /** `owner` is gone. */
    release(owner) {
      drop(owner);
      held.delete(owner);
    },
    /** The loaded hair sheets (and their masks) no owner draws and none has for IDLE_MS. One loaded but not drawn
     *  yet (its pair still on its way: loadHair waits for both) counts from when this first sees it, and one returned
     *  here is forgotten, so loaded again it gets its IDLE_MS again (final review). */
    unused(loaded) {
      const t = now();
      const out = loaded.filter((key) => {
        const sheet = sheetOf(key);
        if (!isHairSheet(sheet) || holders(sheet)) return false;
        if (!letGo.has(sheet)) letGo.set(sheet, t);
        return t - letGo.get(sheet) >= IDLE_MS;
      });
      for (const key of out) letGo.delete(sheetOf(key));
      return out;
    },
  };
}

/** The game's one ledger. */
export const HAIR_SHEETS = createSheetLedger();
